import { IAdserverCampaign, transformCampaign } from '~/src/dash/api/campaign/campaign';
import { createUrl, IHttpResponse, restGet } from '~/src/dash/api/rest';
import { ISessionState } from '~/src/dash/reducers/session-reducers';
import { IMenuList } from '~/src/dash/types/menuList';
import { formatDateEndDay, formatDateStartDay } from '~/src/dash/utils/date';
import { encodeParams } from '~/src/dash/utils/params';

const toCampaignAPIParams = (params: Record<string, any> = {}) => ({
  end_date: formatDateEndDay(params.endDate),
  start_date: formatDateStartDay(params.startDate),
  timezone: params.timezone,
});

export async function getCampaignsMenuList(
  session: ISessionState,
  params: Record<string, any>,
): Promise<Record<string, IMenuList>> {
  const reqUrl = `${createUrl('/simple_campaigns', session.publisher.ID, 'v1')}&${encodeParams(
    toCampaignAPIParams(params),
  )}`;
  return await restGet<any>(reqUrl, {})
    .then((val: IHttpResponse<any>) => {
      const campaigns = val.parsedBody?.campaigns?.map(transformCampaign);
      return {
        campaigns: generateCampaignMenuList(campaigns),
      };
    })
    .catch((e) => {
      console.error(e);
      return {
        campaigns: {},
      };
    });
}

const generateCampaignMenuList = (campaigns: IAdserverCampaign[]): IMenuList => {
  const menuList: IMenuList = {};

  campaigns.forEach((campaign: IAdserverCampaign) => {
    menuList[campaign.ID] = {
      ID: campaign.ID.toString(),
      selected: false,
      title: campaign.Name,
    };
  });

  return menuList;
};
